import {loader} from './loader';
// import fetchJson from '../../lib/fetch-json';
import xhrJson from './xhr-json';
import formSerializeArray from './form-serialize-array';

/**
 *  Working with the network
 */
class Network {
    /**
     * Url
     * @param {String} link
     * @param {Object} data parameters
     * @returns {URL}
     */
    static getUrl(link, data = {}) {
        let url = new URL(link, window.location.origin);

        for (let key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                url.searchParams.set(key, data[key]);
            }
        }

        return url;
    }

    /**
     * Save
     * @param {String} link
     * @param {Object} data parameters
     * @param {String} method
     * @param {String|false} dataFormName
     * @param {Boolean} loaderDetach
     * @param {[]|Array[File]} files
     * @returns {Promise<{}|*>}
     */
    static async call({
        link,
        data = {},
        method = 'GET',
        dataFormName = false,
        loaderDetach = false,
        files = [],
    }) {
        if (!loaderDetach) {
            loader(true);
        }

        let param = {method};
        let url = method === 'POST' ? Network.getUrl(link) : Network.getUrl(link, data);

        if (method === 'POST') {
            let formData = new FormData();

            if (typeof dataFormName === 'string') {
                let dataFromForm = formSerializeArray(dataFormName);

                if (dataFromForm.length) {
                    dataFromForm.forEach((item) => {
                        let {name, value} = item;
                        formData.append(name, value);
                    });
                }
            }

            for (let i in data) {
                if (Object.prototype.hasOwnProperty.call(data, i)) {
                    if (Array.isArray(data[i])) {
                        data[i].forEach((element, index) => {
                            if (typeof element === 'object' && element !== null && !Array.isArray(element)) {
                                for (let k in element) {
                                    if (Object.prototype.hasOwnProperty.call(element, k)) {
                                        if (Array.isArray(element[k])) {
                                            for (let item of element[k]) {
                                                formData.append(`${i}[${k}]`, item);
                                            }
                                        } else {
                                            formData.append(`${i}[${index}][${k}]`, element[k]);
                                        }
                                    }
                                }
                            } else {
                                formData.append(`${i}[${index}]`, element);
                            }
                        });
                    } else {
                        formData.append(i, data[i]);
                    }
                }
            }

            for (let i in files) {
                if ({}.hasOwnProperty.call(files, i)) {
                    if (files[i] instanceof File) {
                        formData.append('file', files[i]);
                    }
                }
            }

            param.body = formData;
        }

        try {
            return await xhrJson(url, param);
            // return await fetchJson(url, param);
        } catch (error) {
            return {};
        }
    }
}

export default Network;
